import { render, staticRenderFns } from "./UploadedCell.vue?vue&type=template&id=349e80b5&scoped=true&"
import script from "./UploadedCell.vue?vue&type=script&lang=js&"
export * from "./UploadedCell.vue?vue&type=script&lang=js&"
import style0 from "./UploadedCell.vue?vue&type=style&index=0&id=349e80b5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "349e80b5",
  null
  
)

export default component.exports